import { LitElement, html, css } from 'lit';
import { customElement, query } from 'lit/decorators.js';
import { setPageTitle } from '../lib/page-title';

/**
 * Embeds the static `components/reference.html` — the exhaustive internal
 * component catalogue (one slide per primitive). Sibling of gallery-page
 * (which embeds the curated showcase `gallery.html`). The Go backend serves
 * /components/* at the parent origin, so the iframe loads its own scripts and
 * styles without isolation pain.
 */
@customElement('reference-page')
export class ReferencePage extends LitElement {
  @query('iframe') private iframeEl?: HTMLIFrameElement;

  static styles = css`
    :host {
      display: block;
      position: fixed;
      inset: 64px 0 0 0;
      background: var(--canvas);
    }
    iframe {
      width: 100%;
      height: 100%;
      border: 0;
      display: block;
    }
  `;

  connectedCallback(): void {
    super.connectedCallback();
    setPageTitle('Reference');
  }

  private onIframeLoad = () => {
    this.iframeEl?.focus();
  };

  render() {
    return html`
      <iframe
        title="Component reference"
        src="/components/reference.html"
        allow="fullscreen"
        @load=${this.onIframeLoad}
      ></iframe>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'reference-page': ReferencePage;
  }
}
